module.exports = __webpack_public_path__ + "img/GT.DeepFoundation.DrivenPile.PrecastConcreteDrivenPileSingle450mm.33435b9e.png";